import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/typography/typography.component.js'

const tagName = 'dap-ds-typography'

/**
 * @element dap-ds-typography
 * @summary Typography is used to display text in different styles.
 * @title - Typography
 *
 * @slot default - The content of the typography.
 *
 * @csspart base - The main typography container.
 *
 * @cssproperty --dds-text-color - The color of the typography.
 * @cssproperty --dds-text-heading-color - The color of the heading typography.
 * @cssproperty --dds-text-description-subtle - The color of the subtle typography.
 * @cssproperty --dds-text-font-family - The font family of the typography.
 * @cssproperty --dds-text-font-weight-medium - The font weight of the medium typography.
 * @cssproperty --dds-text-font-weight-bold - The font weight of the bold typography.
 * @cssproperty --dds-text-font-size-h1 - The font size of the h1 typography.
 * @cssproperty --dds-text-font-size-h2 - The font size of the h2 typography.
 * @cssproperty --dds-text-font-size-h3 - The font size of the h3 typography.
 * @cssproperty --dds-text-font-size-h4 - The font size of the h4 typography.
 * @cssproperty --dds-text-font-size-h5 - The font size of the h5 typography.
 * @cssproperty --dds-text-font-size-h6 - The font size of the h6 typography.
 * @cssproperty --dds-text-font-size-body - The font size of the body typography.
 * @cssproperty --dds-text-font-size-caption - The font size of the caption typography.
 * @cssproperty --dds-text-font-size-description - The font size of the description typography.
 * @cssproperty --dds-text-font-size-description-lg - The font size of the description lg typography.
 * @cssproperty --dds-text-font-size-description-sm - The font size of the description sm typography.
 * @cssproperty --dds-text-font-size-lg - The font size of the lg typography.
 * @cssproperty --dds-text-font-size-md - The font size of the md typography.
 * @cssproperty --dds-text-font-size-sm - The font size of the sm typography.
 * @cssproperty --dds-text-font-size-xs - The font size of the xs typography.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTypography',
})

export default reactWrapper
